import { useCallback } from 'react';
import { reportError } from '../lib/reportError';
import {
  CartUpdateAction,
  CartUpdatePropertyName,
  useCart,
  useUpdateCartMutation
} from './useCart';

export const useGiftCardMutation = () => {
  const [updateCart, { loading, error }] = useUpdateCartMutation();
  const { cart } = useCart();

  const addGiftCard = useCallback(
    async (giftCardNumber: string, giftCardPin: number) => {
      try {
        await updateCart(CartUpdateAction.AddGiftCard, {
          id: cart.id,
          [CartUpdatePropertyName.GiftCard]: giftCardNumber,
          [CartUpdatePropertyName.GiftCardPin]: giftCardPin
        });
      } catch {
        reportError('ADD_GIFT_CARD', error);
      }
    },
    [cart.id, error, updateCart]
  );

  const removeGiftCard = useCallback(async () => {
    try {
      await updateCart(CartUpdateAction.RemoveGiftCard, {
        id: cart.id
      });
    } catch {
      reportError('REMOVE_GIFT_CARD', error);
    }
  }, [cart.id, error, updateCart]);

  return {
    addGiftCard,
    removeGiftCard,
    loading,
    error
  };
};
